export default function scrollBehavior() {
  return {
    x: 0,
    y: 0,
  };
}
